export enum CallbackDetailsState {
  CANCEL = 'CANCEL',
  SAVE = 'SAVE',
  SUCESSO = 'SUCESSO',
  DELETE = 'DELETE',
  REFRESH = 'REFRESH',
  CONTESTA = 'CONTESTA',
  APPROVA = 'APPROVA',
  RIFIUTA = 'RIFIUTA',
  RIVENDICA = 'RIVENDICA',
  RIPRENDI = 'RIPRENDI',
  CRIFIUTO = "CRIFIUTO",
  NCRIFIUTO = "NCRIFIUTO",
  ACCETTA = "ACCETTA",
  Rpulizie = "Rpulizie",
  Cpulizie = "Cpulizie",
  CHIUDI = "CHIUDI",
  CONFERMA = "CONFERMA"
}
